import { RouteObject } from "react-router-dom";
import LegacyIFrame from "../pages/Legacy/LegacyIFrame";

/*
Paths that are legacy and private but authentication/login 
should be handled by the events page itself
*/
export const events_legacy_paths = [
  "/meetingaccomodation",
  "/postevent",
  "/meetingregistration",
];

export const publicLegacyPaths = [
  "/joinwsg.asp",
  "/wsg_practicegroups.asp",
  "/customsearch.asp",
  "/profile/*",
  "/profile/attorney/*",
  "/wsg_members.asp",
  "/members.asp",
  "/wsg_groups.asp",
  "/gcinsights.asp",
  "/gcinsights/*",
  "/blog",
  "/blog/featuredblog.aspx",
  "/blog/default.aspx",
  "/wsgbynumbers.asp",
  "/wsg_objectives.asp",
  "/bod.asp",
  "/council.asp",
  "/wsg_practicegroupregions.asp",
  "/meeting2",
  "/meetingcontacts",
  "/publications.asp",
  "/releases.asp",
  "/success_stories.asp",
  "/networkwire_3q2024.asp",
  "/newsfeeds",
  "/wsglearninginstitute_marketingworkshop.asp",
  "/networkwire_4q2024.asp",
  "/wsg-knowledge-center.asp",
  "/manage_events.asp",
  "/meetingregistrants",
  "/meetingagenda",
  "/submit_stories.asp",
  "/manage_publications.asp",
  "/manage_releases.asp",
  "/submitrelease.asp",
  "/submitarticle.asp",
  "/secondments.asp",
  "/dealmaker.asp",
  "/help.asp",
  "/wsglearninginstitute_growthplayrecap_sessions.asp",
  "/member/*",
  "/meetingphotos",
  "/VisitorInfo",
  "/sitemap.asp",
  "/privacypolicy.asp",
  "/disclaimer.asp",
  "/wsg_groupleadership.asp",
  "/networkwire_1q2025.asp",
  "/webcontacts.asp",
  "/contacts.asp",
  "/contact.asp",
  "/wsg_notificationemails.asp",
  "/members-locations.asp",
  "/dashboard.asp",
  "/manage_doingbizguide.asp",
  "/webcontacts_new.asp",
  "/meetingpayment.aspx",
  "/meetingpayment",
  "/networkwire_2q2025.asp",
  "/search-special.asp",
  "/advanced-search.asp",
  "/wsg_practiceinvitemembers.asp",
  "/members",
  "/blog/post/*",
  "/networkwire_3q2025.asp",
  "/networkwire_4q2025.asp",
  "/wsg-brand-and-guidelines.asp",
  "/firmofficeprofile.asp",
  "/networkwire_1q2026.asp",
  "/wsg-marketing-collateral.asp",
  "/wsg-in-action.asp",
  "/members.asp/*",
  '/meeting-unsubscribe.asp',
  '/email-subscription.asp',
  '/press-subscription.asp',
  '/networkwire-subscription.asp',
  '/publications-subscription.asp',
  '/stories-subscription.asp',
  '/groups13.asp',
  '/wsg_projects13.asp',
  '/wsg_privateforums.asp',
  '/wsg_practiceforums.asp',
  '/ajaxdb_forums.asp',
  '/wsg_practiceblogs.asp',
  '/my_preferences.asp',
  '/subscriptions.asp',
  '/wsg-brand-guides.asp',
  '/networkwire_2q2026.asp',
  '/networkwire_3q2026.asp',
];

const generateLegacyRoutes = (paths: string[]): RouteObject[] => {
  const routes = [
    ...paths,
    ...events_legacy_paths, // Include the events legacy paths
  ];
  return routes.map((path) => ({
    path,
    element: <LegacyIFrame />,
  }));
};

export const PublicLegacyRoutes: RouteObject[] =
  generateLegacyRoutes(publicLegacyPaths);
